import { type FC } from 'react';
import { useTranslations } from 'next-intl';

import routes from '@shared/routes';
import { Box, Button, Divider, Flex, Icons, Text } from '@shared/ui-kit';

const EmptyState: FC = () => {
  const t = useTranslations();

  return (
    <Flex
      data-testid="merchants-list-empty-state"
      direction="column"
      rowGap="4"
      alignItems="center"
      pt="20"
    >
      <Icons.Parcel
        w="28"
        h="28"
        color="gray.500"
        mb={4}
      />
      <Text
        fontSize="2xl"
        fontWeight="700"
      >
        {t('General.nothingFound')}
      </Text>
      <Text fontSize="lg">{t('General.tryChangeFilters')}</Text>
      <Box
        m="auto"
        py="3"
        maxW="40"
        w="full"
      >
        <Divider />
      </Box>

      <Button
        leftIcon={<Icons.Add w={2.5} />}
        size="md"
        href={routes.import}
      >
        {t('General.importData')}
      </Button>
    </Flex>
  );
};

export default EmptyState;
